import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ReduxProvider from "./ReduxProvider";
import ThemeProvider from "./ThemeProvider";
import SessionSyncProvider from "./SessionSyncProvider";
import { GlobalSearchProvider } from "@/hooks/useGlobalSearch.jsx";

import "react-toastify/dist/ReactToastify.css";

export const Providers = ({ children }) => {
  return (
    <BrowserRouter>
      <ReduxProvider>
        <SessionSyncProvider>
          <ThemeProvider>
            <GlobalSearchProvider>
              {children}
              <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
              />
            </GlobalSearchProvider>
          </ThemeProvider>
        </SessionSyncProvider>
      </ReduxProvider>
    </BrowserRouter>
  );
};

export default Providers;
